module.exports = __webpack_public_path__ + "img/plumber.133aa369.jpg";